module.exports = __webpack_public_path__ + "static/media/ltc-qr.6c76018c.png";